import React from "react";

/**
 * Shared "Go Back" button used across app detail sub-views (AI CMO Analysis,
 * Forecasting, Social Comparison, etc.) so they visually match the main
 * "← Go Back" button on the App Store listing page (gameDashboard.jsx).
 */
const BackButton = ({ onClick, label = "Go Back", className = "", style = {}, disabled = false }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#2a2b37",
                color: "#f43f5e",
                padding: "5px 10px",
                borderRadius: "6px",
                fontWeight: 600,
                border: "1px solid #3a3b47",
                fontSize: "0.85rem",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
                transition: "0.2s",
                whiteSpace: "nowrap",
                ...style,
            }}
            onMouseEnter={e => {
                e.currentTarget.style.background = "#3a3b47";
                e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={e => {
                e.currentTarget.style.background = "#2a2b37";
                e.currentTarget.style.color = "#f43f5e";
            }}
        >
            &larr; {label}
        </button>
    );
};

export default BackButton;
